import { Button } from '@/ui/design-system/components/ui/button';
import { FiFileText } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { mixpanelTrack } from 'utils/app/configureMixpanel';

/**
 * Persistent "View report" chip for a report the assistant created in this
 * chat (a successful create_report tool part). Renders purely from the part's
 * output, so a persisted session restores the chip with zero live context —
 * same model as the persisted data-navigation banner.
 */
const CreateReportChip = ({ output }) => {
    const url = output.url ?? `/reports/${output.report_id}/view`;
    return (
        <Button
            asChild
            variant="outline"
            size="sm"
            className="self-start border-primary/30 bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary"
        >
            <Link
                to={url}
                onClick={() =>
                    mixpanelTrack('AI Assistant Report Chip Clicked', {
                        report_id: output.report_id,
                    })
                }
            >
                <span className="size-4 shrink-0 flex items-center">
                    <FiFileText />
                </span>
                {output.title ? `View report · ${output.title}` : 'View report'}
            </Link>
        </Button>
    );
};

export default CreateReportChip;
